__turbopack_context__.v({
  "className": "jetbrains_mono_c290d72c-module__dNxYvq__className",
  "variable": "jetbrains_mono_c290d72c-module__dNxYvq__variable",
});
